<template>
  <div class="app-container">
    <div class="nav-sidebar">
      <div
        v-for="(item, index) in navItems"
        :key="index"
        :class="['nav-item', { active: currentNav === item.key }]"
        @click="handleTab(item.key)"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="content-area">
      <div v-show="currentNav === 'digital-human'" class="digital-human">
        <!-- 配置区域 -->
        <div class="config-panel">
          <div class="config-title">数字人配置</div>
          <div class="config-grid">
            <div class="config-item">
              <label>API地址:</label>
              <input v-model="config.apiBaseUrl" placeholder="请输入API地址" class="config-input" />
            </div>
            <div class="config-item">
              <label>并发ID:</label>
              <input v-model="config.concurrencyId" placeholder="请输入并发ID" class="config-input" />
            </div>
            <div class="config-item">
              <label>数字人ID:</label>
              <input v-model.number="config.avatarId" placeholder="请输入数字人ID" class="config-input" type="number" />
            </div>
            <div class="config-item">
              <label>声音ID:</label>
              <input v-model="config.ttsId" placeholder="请输入声音ID" class="config-input" />
            </div>
            <div class="config-item">
              <label>应用ID:</label>
              <input v-model="config.appId" placeholder="请输入应用ID" class="config-input" />
            </div>
            <div class="config-item">
              <label>环境:</label>
              <select v-model="config.env" class="config-select">
                <option v-for="item in envOptions" :key="item.value" :value="item.value">
                  {{ item.label }}
                </option>
              </select>
            </div>
            <div class="config-item">
              <label>授权ID:</label>
              <input v-model="config.authorizeId" placeholder="请输入授权ID" class="config-input" />
            </div>
          </div>
        </div>

        <div class="display-area" >

          <div v-show="loadingSzr" class="loading-container">
            <div class="loading-spinner"></div>
            <div class="loading-text">正在加载数字人...</div>
          </div>
          <div id="video-container" v-show="!loadingSzr">

          </div>
        </div>
        <div class="message-input-area">
          <textarea
            v-model="digitalHumanMessage"
            placeholder="请输入要发送给数字人的消息"
            class="message-textarea"
          ></textarea>
        </div>
        <div class="control-buttons">
          <button @click="initDigitalHuman" :disabled="initSzr">
            初始化数字人
          </button>
          <button @click="sendMessage" :disabled="!digitalHumanMessage">
            发送消息
          </button>
          <button @click="sendStreamingMessage" :disabled="!initSzr || !digitalHumanMessage">
            发送流式文本
          </button>
          <button @click="stopSpeaking" :disabled="!initSzr">停止说话</button>
          <button @click="closeSession" :disabled="!initSzr">关闭会话</button>
        </div>
      </div>

    </div>
    <div class="toast" v-if="showToast">
      <div class="toast-content">
        {{ toastMessage }}
      </div>
    </div>
  </div>
</template>

<script>
// @ts-nocheck

import { SzrPlayer } from "@/assets/szrSdk.js";
export default {
  name: "App",
  data() {
    return {
      currentNav: "digital-human",
      navItems: [
        { name: "数字人", key: "digital-human" },
      ],
      recognitionText: "",
      synthesisText: "",
      digitalHumanMessage: "",
      player: null,
      tts: null,
      audioUrl: null,
      audioPlayer: null,
      asr: null,
      initAsr: false,
      startAsr: false,
      initTts: false,
      initSzr: false,
      loadingSzr: false,
      showToast: false,
      toastMessage: '',
      toastTimer: null,
      // 数字人配置
      config: {
        apiBaseUrl: "https://szrstream.smart-xiaoduo.cn:64441/api/v1/live",
        concurrencyId: "ccxy20e09aa4f5a5b878",
        avatarId: 10002,
        ttsId: "S_9klUxIJj1",
        appId: "xy623f6b80f0b0499f",
       // env: "dev",
        authorizeId: "1489b164wqfsad68f3d592264bc1185"
      },
      // 环境选项
      envOptions: [
        { label: '开发环境', value: 'dev' },
        { label: '生产环境', value: 'prod' },
      ],
    };
  },
  created() {
    // 添加页面刷新/关闭事件监听
    window.addEventListener("beforeunload", this.handleBeforeUnload);
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    // 确保在组件销毁时也清理数字人实例
    if (this.player) {
      this.player.destroy();
    }
    // 清理音频资源
    if (this.audioUrl) {
      window.URL.revokeObjectURL(this.audioUrl);
    }
    if (this.audioPlayer) {
      this.audioPlayer.pause();
      this.audioPlayer = null;
    }
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  },
  methods: {
    handleTab (key) {
      this.currentNav = key;
      if (key != 'digital-human' && this.initSzr) {
        //this.player.destroy()
      }
    },
    handleBeforeUnload() {
      // 页面刷新/关闭前清理数字人实例
      if (this.player) {
        this.player.destroy();
      }
    },
    showToastMessage(message) {
      this.toastMessage = message;
      this.showToast = true;
      if (this.toastTimer) {
        clearTimeout(this.toastTimer);
      }
      this.toastTimer = setTimeout(() => {
        this.showToast = false;
      }, 3000);
    },
    initDigitalHuman() {
      this.loadingSzr = true; // 开始加载，显示loading
      let params = {
        containerId: "video-container", // 容器id
        concurrencyId: this.config.concurrencyId, // 并发id
        avatarId: this.config.avatarId, // 数字人id
        ttsId: this.config.ttsId, // 数字人声音
        appId: this.config.appId, // 应用id
        env: this.config.env, //环境变量
        apiBaseUrl: this.config.apiBaseUrl, // 使用配置的API地址
        authorizeId: this.config.authorizeId, // 授权id
        isWsAsk: true, //开启流式输入
				askWsUrl: 'wss://szrstream.smart-xiaoduo.cn:64441/api/v1/live/ws', //流式输入ws地址
      }
      console.log(params,'params')
      this.player = new SzrPlayer(params);
      
      // 订阅 streamStatus 事件
      this.player.subscribe("streamStatus", (status) => {
        console.log("Stream status changed:", status);
        if (status === "1") {
          console.log("数字人开始说话");
          this.loadingSzr = false; // 加载完成，隐藏loading
          this.initSzr = true;
        } else if (status === "-1") {
          console.log("数字人结束说话");
        }
      });
      this.player.subscribe("errorLog", (data) => {
        console.log("error info:", data);
        this.loadingSzr = false; // 出错时隐藏loading
        this.showToastMessage('并发已满，请稍后重试');
        // if (data.includes('并发已满')) {
        //   this.showToastMessage('并发已满，请稍后重试');
        // }
      });
      // TODO: 实现初始化数字人功能
      console.log("初始化数字人");
    },
    sendMessage() {
      // TODO: 实现发送消息功能
      console.log("发送消息");
      this.player
        .sendMessage(this.digitalHumanMessage)
        .catch((error) => console.error("Send message error:", error));
      this.digitalHumanMessage = ""; // 清空输入框
    },
    sendStreamingMessage() {
      if (!this.initSzr || !this.digitalHumanMessage) {
        return;
      }
      const message = this.digitalHumanMessage;
      const chunkSize = 10; // 每个片段的字符数
      const delay = 200; // 每个片段发送间隔(ms)
      const chunks = [];
      
      // 将消息拆分成多个片段
      for (let i = 0; i < message.length; i += chunkSize) {
        chunks.push(message.slice(i, i + chunkSize));
      }
      
      let index = 0;
      
      // 发送开始标识 (end_flag: 0)
      this.player.sendAskMessage(JSON.stringify({
        end_flag: 0,
        Content: chunks[index] || ""
      }));
      console.log("流式文本开始发送:", chunks[index]);
      index++;
      
      // 使用定时器模拟流式发送
      const timer = setInterval(() => {
        if (index < chunks.length - 1) {
          // 发送中标识 (end_flag: 1)
          this.player.sendAskMessage(JSON.stringify({
            end_flag: 1,
            Content: chunks[index]
          }));
          console.log("流式文本发送中:", chunks[index]);
          index++;
        } else if (index === chunks.length - 1) {
          // 发送最后一个片段，发送结束标识 (end_flag: 2)
          this.player.sendAskMessage(JSON.stringify({
            end_flag: 2,
            Content: chunks[index]
          }));
          console.log("流式文本发送完成:", chunks[index]);
          index++;
          clearInterval(timer);
          this.digitalHumanMessage = ""; // 清空输入框
        }
      }, delay);
    },
    stopSpeaking() {
      this.player
        .breakTalk()
        .catch((error) => console.error("Break talk error:", error));
      // TODO: 实现停止说话功能
      console.log("停止说话");
    },
    closeSession() {
      this.player.destroy();
      this.initSzr = false;
      // TODO: 实现关闭会话功能
      console.log("关闭会话");
    },
    playAudio() {
      if (this.audioUrl) {
        if (this.audioPlayer) {
          this.audioPlayer.pause();
          this.audioPlayer.currentTime = 0;
        }
        this.audioPlayer = new Audio(this.audioUrl);
        this.audioPlayer.play();
      }
    },
    downloadAudio() {
      if (!this.audioUrl) {
        return;
      }
      // 创建一个临时的a标签用于下载
      const link = document.createElement("a");
      link.href = this.audioUrl;
      // 设置下载文件名，使用时间戳确保文件名唯一
      link.download = `语音合成_${new Date().getTime()}.mp3`;
      // 添加到文档中
      document.body.appendChild(link);
      // 触发点击事件
      link.click();
      // 清理DOM
      document.body.removeChild(link);
    },
  },
};
</script>

<style>
.app-container {
  display: flex;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.nav-sidebar {
  width: 160px;
  background-color: #f5f5f5;
  padding: 15px 0;
  border-right: 1px solid #ddd;
  height: 100%;
  box-sizing: border-box;
}

.nav-item {
  padding: 12px 15px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  margin: 4px 0;
}

.nav-item:hover {
  background-color: #e0e0e0;
}

.nav-item.active {
  background-color: #1890ff;
  color: white;
}

.content-area {
  flex: 1;
  padding: 15px;
  background-color: #fff;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}

.digital-human {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.digital-human .display-area {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #000; */
  margin-bottom: 10px;
  border-radius: 4px;
  min-height: 0; /* 防止flex子元素溢出 */
  position: relative;
}

.loading-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* background-color: #000; */
  z-index: 10;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #1890ff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-text {
  margin-top: 16px;
  color: #fff;
  font-size: 14px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.config-panel {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.config-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
}

.config-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.config-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.config-item label {
  white-space: nowrap;
  font-size: 13px;
  color: #666;
  min-width: 60px;
}

.config-input {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
}

.config-input:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.config-select {
  flex: 1;
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 13px;
  background-color: #fff;
  cursor: pointer;
}

.config-select:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.speech-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.speech-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  border-radius: 8px;
  padding: 15px;
}

.speech-section h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
}

.text-display-area {
  flex: 1;
  border: 1px solid #ddd;
  padding: 15px;
  margin-bottom: 15px;
  border-radius: 4px;
  overflow-y: auto;
  background-color: #fff;
  min-height: 150px;
}

.text-input-area {
  flex: 1;
  padding: 15px;
  margin-bottom: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: none;
  background-color: #fff;
  min-height: 150px;
}

.control-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 0;
  background-color: transparent;
  flex-shrink: 0; /* 防止按钮区域被压缩 */
}

.control-buttons button {
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  min-width: 100px;
}

.control-buttons button:hover {
  background-color: #40a9ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.control-buttons button:active {
  transform: translateY(0);
  box-shadow: none;
}

.message-input-area {
  margin-bottom: 10px;
  flex-shrink: 0; /* 防止输入框被压缩 */
}

.message-textarea {
  width: 100%;
  height: 60px; /* 减小高度 */
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  resize: none;
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
}

.message-textarea:focus {
  outline: none;
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.control-buttons button:disabled {
  background-color: #d9d9d9;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.control-buttons button:disabled:hover {
  background-color: #d9d9d9;
  transform: none;
  box-shadow: none;
}

.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
}

.toast-content {
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 12px 24px;
  border-radius: 4px;
  font-size: 14px;
  animation: fadeInOut 3s ease-in-out;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(-20px);
  }
  10% {
    opacity: 1;
    transform: translateY(0);
  }
  90% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
    transform: translateY(-20px);
  }
}

.url-input {
  display: none;
}
#video-container {
  width: 100%;
  height: 100%;
}
</style>
